export default __webpack_public_path__ + "static/assets/c9e83835806c0aae5b2b372beec67417.png";